import {
  API, GET, POST, PUT, PATCH, DELETE,
} from '../middleware/api';
import { API_URL } from '../config';

// Workshop Chains

export function fetchChains(params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/workshop_chain/`,
      types: [
        'FETCH_CHAINS_REQUEST',
        'FETCH_CHAINS_SUCCESS',
        'FETCH_CHAINS_FAIL',
      ],
      params,
    },
  };
}

export function fetchChain(chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/workshop_chain/${chainId}/`,
      types: [
        'FETCH_CHAIN_REQUEST',
        'FETCH_CHAIN_SUCCESS',
        'FETCH_CHAIN_FAIL',
      ],
    },
  };
}

export function createChain(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/workshop_chain/`,
      types: [
        'CREATE_CHAIN_REQUEST',
        'CREATE_CHAIN_SUCCESS',
        'CREATE_CHAIN_FAIL',
      ],
      data,
    },
  };
}

export function deleteChain(chainId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/workshop_chain/${chainId}/`,
      types: [
        'DELETE_CHAIN_REQUEST',
        'DELETE_CHAIN_SUCCESS',
        'DELETE_CHAIN_FAIL',
      ],
      additionalData: { chainId },
    },
  };
}

export function updateChain(chainId, data) {
  return {
    [API]: {
      method: PUT,
      url: `${API_URL}/uiapi/1/workshop_chain/${chainId}/`,
      types: [
        'UPDATE_CHAIN_REQUEST',
        'UPDATE_CHAIN_SUCCESS',
        'UPDATE_CHAIN_FAIL',
      ],
      data,
    },
  };
}

// Chain Permissions

export function fetchChainPermissions(chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/workshop_chain_permission/`,
      types: [
        'FETCH_CHAIN_PERMISSIONS_REQUEST',
        'FETCH_CHAIN_PERMISSIONS_SUCCESS',
        'FETCH_CHAIN_PERMISSIONS_FAIL',
      ],
      params: { chain_id: chainId },
    },
  };
}

export function createChainPermission(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/workshop_chain_permission/`,
      types: [
        'CREATE_CHAIN_PERMISSION_REQUEST',
        'CREATE_CHAIN_PERMISSION_SUCCESS',
        'CREATE_CHAIN_PERMISSION_FAIL',
      ],
      data,
    },
  };
}

export function updateChainPermission(permissionId, data) {
  return {
    [API]: {
      method: PUT,
      url: `${API_URL}/uiapi/1/workshop_chain_permission/${permissionId}/`,
      types: [
        'UPDATE_CHAIN_PERMISSION_REQUEST',
        'UPDATE_CHAIN_PERMISSION_SUCCESS',
        'UPDATE_CHAIN_PERMISSION_FAIL',
      ],
      data,
    },
  };
}

export function deleteChainPermission(permissionId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/workshop_chain_permission/${permissionId}/`,
      types: [
        'DELETE_CHAIN_PERMISSION_REQUEST',
        'DELETE_CHAIN_PERMISSION_SUCCESS',
        'DELETE_CHAIN_PERMISSION_FAIL',
      ],
      additionalData: { permissionId },
    },
  };
}

// Chain Memberships (Workshops in chain)

export function fetchChainMemberships(chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/workshop_chain_membership/`,
      types: [
        'FETCH_CHAIN_MEMBERSHIPS_REQUEST',
        'FETCH_CHAIN_MEMBERSHIPS_SUCCESS',
        'FETCH_CHAIN_MEMBERSHIPS_FAIL',
      ],
      params: { chain_id: chainId },
    },
  };
}

export function createChainMembership(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/workshop_chain_membership/`,
      types: [
        'CREATE_CHAIN_MEMBERSHIP_REQUEST',
        'CREATE_CHAIN_MEMBERSHIP_SUCCESS',
        'CREATE_CHAIN_MEMBERSHIP_FAIL',
      ],
      data,
    },
  };
}

export function updateChainMembership(membershipId, data) {
  return {
    [API]: {
      method: PUT,
      url: `${API_URL}/uiapi/1/workshop_chain_membership/${membershipId}/`,
      types: [
        'UPDATE_CHAIN_MEMBERSHIP_REQUEST',
        'UPDATE_CHAIN_MEMBERSHIP_SUCCESS',
        'UPDATE_CHAIN_MEMBERSHIP_FAIL',
      ],
      data,
    },
  };
}

export function deleteChainMembership(membershipId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/workshop_chain_membership/${membershipId}/`,
      types: [
        'DELETE_CHAIN_MEMBERSHIP_REQUEST',
        'DELETE_CHAIN_MEMBERSHIP_SUCCESS',
        'DELETE_CHAIN_MEMBERSHIP_FAIL',
      ],
      additionalData: { membershipId },
    },
  };
}

// Chain Care Services

export function fetchChainCareServices(chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_care_service/`,
      types: [
        'FETCH_CHAIN_CARE_SERVICES_REQUEST',
        'FETCH_CHAIN_CARE_SERVICES_SUCCESS',
        'FETCH_CHAIN_CARE_SERVICES_FAIL',
      ],
      params: { chain_id: chainId },
    },
  };
}

export function inviteToChainCareService(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_care_service/invite/`,
      types: [
        'INVITE_CHAIN_CARE_SERVICE_REQUEST',
        'INVITE_CHAIN_CARE_SERVICE_SUCCESS',
        'INVITE_CHAIN_CARE_SERVICE_FAIL',
      ],
      data,
    },
  };
}

export function deleteChainCareService(careServiceId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/chain_care_service/${careServiceId}/`,
      types: [
        'DELETE_CHAIN_CARE_SERVICE_REQUEST',
        'DELETE_CHAIN_CARE_SERVICE_SUCCESS',
        'DELETE_CHAIN_CARE_SERVICE_FAIL',
      ],
      additionalData: { careServiceId },
    },
  };
}

// Chain Care Service Invitations

export function fetchChainCareServiceInvitations(chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_care_service_invitation/`,
      types: [
        'FETCH_CHAIN_CARE_SERVICE_INVITATIONS_REQUEST',
        'FETCH_CHAIN_CARE_SERVICE_INVITATIONS_SUCCESS',
        'FETCH_CHAIN_CARE_SERVICE_INVITATIONS_FAIL',
      ],
      params: chainId ? { chain_id: chainId } : {},
    },
  };
}

export function acceptChainCareServiceInvitation(invitationId, data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_care_service_invitation/${invitationId}/accept/`,
      types: [
        'ACCEPT_CHAIN_CARE_SERVICE_INVITATION_REQUEST',
        'ACCEPT_CHAIN_CARE_SERVICE_INVITATION_SUCCESS',
        'ACCEPT_CHAIN_CARE_SERVICE_INVITATION_FAIL',
      ],
      data,
    },
  };
}

export function rejectChainCareServiceInvitation(invitationId, data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_care_service_invitation/${invitationId}/reject/`,
      types: [
        'REJECT_CHAIN_CARE_SERVICE_INVITATION_REQUEST',
        'REJECT_CHAIN_CARE_SERVICE_INVITATION_SUCCESS',
        'REJECT_CHAIN_CARE_SERVICE_INVITATION_FAIL',
      ],
      data: data || {},
    },
  };
}

// Chain Care Service Vehicles

export function fetchChainCareServiceVehicles(chainId, params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_care_service_vehicle/`,
      types: [
        'FETCH_CHAIN_CARE_SERVICE_VEHICLES_REQUEST',
        'FETCH_CHAIN_CARE_SERVICE_VEHICLES_SUCCESS',
        'FETCH_CHAIN_CARE_SERVICE_VEHICLES_FAIL',
      ],
      params: { chain_id: chainId, ...params },
    },
  };
}

export function addChainCareServiceVehicle(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_care_service_vehicle/`,
      types: [
        'ADD_CHAIN_CARE_SERVICE_VEHICLE_REQUEST',
        'ADD_CHAIN_CARE_SERVICE_VEHICLE_SUCCESS',
        'ADD_CHAIN_CARE_SERVICE_VEHICLE_FAIL',
      ],
      data,
    },
  };
}

export function removeChainCareServiceVehicle(vehicleMappingId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/chain_care_service_vehicle/${vehicleMappingId}/`,
      types: [
        'REMOVE_CHAIN_CARE_SERVICE_VEHICLE_REQUEST',
        'REMOVE_CHAIN_CARE_SERVICE_VEHICLE_SUCCESS',
        'REMOVE_CHAIN_CARE_SERVICE_VEHICLE_FAIL',
      ],
      additionalData: { vehicleMappingId },
    },
  };
}

export function assignWorkshopToVehicle(vehicleMappingId, workshopId) {
  return {
    [API]: {
      method: PUT,
      url: `${API_URL}/uiapi/1/chain_care_service_vehicle/${vehicleMappingId}/assign_workshop/`,
      types: [
        'ASSIGN_WORKSHOP_TO_VEHICLE_REQUEST',
        'ASSIGN_WORKSHOP_TO_VEHICLE_SUCCESS',
        'ASSIGN_WORKSHOP_TO_VEHICLE_FAIL',
      ],
      data: { workshop_id: workshopId },
    },
  };
}

// Maintenance Reservations

export function fetchMaintenanceReservations(chainId, params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/maintenance_reservation/`,
      types: [
        'FETCH_MAINTENANCE_RESERVATIONS_REQUEST',
        'FETCH_MAINTENANCE_RESERVATIONS_SUCCESS',
        'FETCH_MAINTENANCE_RESERVATIONS_FAIL',
      ],
      params: { chain_id: chainId, ...params },
    },
  };
}

// CS Maintenance Reservations (service portal context)

export function fetchCSMaintenanceReservations(workshopId, params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/cs_maintenance_reservation/`,
      types: [
        'FETCH_CS_MAINTENANCE_RESERVATIONS_REQUEST',
        'FETCH_CS_MAINTENANCE_RESERVATIONS_SUCCESS',
        'FETCH_CS_MAINTENANCE_RESERVATIONS_FAIL',
      ],
      params: { workshop_id: workshopId, ...params },
    },
  };
}

// Chain Parts Analysis

export function fetchChainPartsAnalysis(chainId, params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_parts_analysis/`,
      types: [
        'FETCH_CHAIN_PARTS_ANALYSIS_REQUEST',
        'FETCH_CHAIN_PARTS_ANALYSIS_SUCCESS',
        'FETCH_CHAIN_PARTS_ANALYSIS_FAIL',
      ],
      params: { chain_id: chainId, ...params },
    },
  };
}

export function fetchChainPartsAnalysisSummary(chainId, params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_parts_analysis/summary/`,
      types: [
        'FETCH_CHAIN_PARTS_ANALYSIS_SUMMARY_REQUEST',
        'FETCH_CHAIN_PARTS_ANALYSIS_SUMMARY_SUCCESS',
        'FETCH_CHAIN_PARTS_ANALYSIS_SUMMARY_FAIL',
      ],
      params: { chain_id: chainId, ...params },
    },
  };
}

// Reservation Parts (for parts accordion in upcoming maintenances view)

export function fetchReservationParts(reservationId, chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/maintenance_reservation/${reservationId}/parts/`,
      types: [
        'FETCH_RESERVATION_PARTS_REQUEST',
        'FETCH_RESERVATION_PARTS_SUCCESS',
        'FETCH_RESERVATION_PARTS_FAIL',
      ],
      params: { chain_id: chainId },
      additionalData: { reservationId },
    },
  };
}

// Chain Maintenance Details (for parts accordion in parts usage view)

export function fetchChainMaintenanceDetails(maintenanceId, chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/vehicle_maintenance/${maintenanceId}/`,
      types: [
        'FETCH_CHAIN_MAINTENANCE_DETAILS_REQUEST',
        'FETCH_CHAIN_MAINTENANCE_DETAILS_SUCCESS',
        'FETCH_CHAIN_MAINTENANCE_DETAILS_FAIL',
      ],
      params: { chain_id: chainId },
      additionalData: { maintenanceId },
    },
  };
}

// Vehicle approval statuses for parts usage view

export function fetchVehicleApprovalStatuses(chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_parts_analysis/vehicle_approval_statuses/`,
      types: [
        'FETCH_VEHICLE_APPROVAL_STATUSES_REQUEST',
        'FETCH_VEHICLE_APPROVAL_STATUSES_SUCCESS',
        'FETCH_VEHICLE_APPROVAL_STATUSES_FAIL',
      ],
      params: { chain_id: chainId },
    },
  };
}

// Chain Invoice Settings

export function fetchChainInvoiceSettings(chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_invoice_settings/`,
      types: [
        'FETCH_CHAIN_INVOICE_SETTINGS_REQUEST',
        'FETCH_CHAIN_INVOICE_SETTINGS_SUCCESS',
        'FETCH_CHAIN_INVOICE_SETTINGS_FAIL',
      ],
      params: { chain_id: chainId },
    },
  };
}

export function updateChainInvoiceSettings(settingsId, data) {
  return {
    [API]: {
      method: PUT,
      url: `${API_URL}/uiapi/1/chain_invoice_settings/${settingsId}/`,
      types: [
        'UPDATE_CHAIN_INVOICE_SETTINGS_REQUEST',
        'UPDATE_CHAIN_INVOICE_SETTINGS_SUCCESS',
        'UPDATE_CHAIN_INVOICE_SETTINGS_FAIL',
      ],
      data,
    },
  };
}

// Chain Netvisor Settings

export function fetchChainNetvisorSettings(chainId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_netvisor_settings/`,
      types: [
        'FETCH_CHAIN_NETVISOR_SETTINGS_REQUEST',
        'FETCH_CHAIN_NETVISOR_SETTINGS_SUCCESS',
        'FETCH_CHAIN_NETVISOR_SETTINGS_FAIL',
      ],
      params: { chain_id: chainId },
    },
  };
}

export function updateChainNetvisorSettings(settingsId, data) {
  return {
    [API]: {
      method: PUT,
      url: `${API_URL}/uiapi/1/chain_netvisor_settings/${settingsId}/`,
      types: [
        'UPDATE_CHAIN_NETVISOR_SETTINGS_REQUEST',
        'UPDATE_CHAIN_NETVISOR_SETTINGS_SUCCESS',
        'UPDATE_CHAIN_NETVISOR_SETTINGS_FAIL',
      ],
      data,
    },
  };
}

export function testNetvisorConnection(chainId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_netvisor_settings/test_connection/`,
      types: [
        'TEST_NETVISOR_CONNECTION_REQUEST',
        'TEST_NETVISOR_CONNECTION_SUCCESS',
        'TEST_NETVISOR_CONNECTION_FAIL',
      ],
      data: { chain_id: chainId },
    },
  };
}

// Chain Care Service Update

export function updateChainCareService(careServiceId, data) {
  return {
    [API]: {
      method: PUT,
      url: `${API_URL}/uiapi/1/chain_care_service/${careServiceId}/`,
      types: [
        'UPDATE_CHAIN_CARE_SERVICE_REQUEST',
        'UPDATE_CHAIN_CARE_SERVICE_SUCCESS',
        'UPDATE_CHAIN_CARE_SERVICE_FAIL',
      ],
      data,
    },
  };
}

// Chain Customer Mappings

export function fetchChainCustomerMappings(careServiceId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_workshop_customer_mapping/`,
      types: [
        'FETCH_CHAIN_CUSTOMER_MAPPINGS_REQUEST',
        'FETCH_CHAIN_CUSTOMER_MAPPINGS_SUCCESS',
        'FETCH_CHAIN_CUSTOMER_MAPPINGS_FAIL',
      ],
      params: { chain_care_service_id: careServiceId },
    },
  };
}

export function discoverCustomerMappings(careServiceId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_workshop_customer_mapping/discover/`,
      types: [
        'DISCOVER_CUSTOMER_MAPPINGS_REQUEST',
        'DISCOVER_CUSTOMER_MAPPINGS_SUCCESS',
        'DISCOVER_CUSTOMER_MAPPINGS_FAIL',
      ],
      data: { chain_care_service_id: careServiceId },
    },
  };
}

export function discoverSingleCustomerMapping(careServiceId, membershipId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_workshop_customer_mapping/discover_single/`,
      types: [
        'DISCOVER_SINGLE_CUSTOMER_MAPPING_REQUEST',
        'DISCOVER_SINGLE_CUSTOMER_MAPPING_SUCCESS',
        'DISCOVER_SINGLE_CUSTOMER_MAPPING_FAIL',
      ],
      data: { chain_care_service_id: careServiceId, membership_id: membershipId },
    },
  };
}

export function updateCustomerMapping(mappingId, data) {
  return {
    [API]: {
      // PATCH: the backend's manual-override logic lives in partial_update.
      method: PATCH,
      url: `${API_URL}/uiapi/1/chain_workshop_customer_mapping/${mappingId}/`,
      types: [
        'UPDATE_CUSTOMER_MAPPING_REQUEST',
        'UPDATE_CUSTOMER_MAPPING_SUCCESS',
        'UPDATE_CUSTOMER_MAPPING_FAIL',
      ],
      data,
    },
  };
}

// Purchase Invoices

export function fetchPurchaseInvoices(chainId, params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_purchase_invoice/`,
      types: [
        'FETCH_PURCHASE_INVOICES_REQUEST',
        'FETCH_PURCHASE_INVOICES_SUCCESS',
        'FETCH_PURCHASE_INVOICES_FAIL',
      ],
      params: { chain_id: chainId, ...params },
    },
  };
}

export function fetchPurchaseInvoice(invoiceId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_purchase_invoice/${invoiceId}/`,
      types: [
        'FETCH_PURCHASE_INVOICE_REQUEST',
        'FETCH_PURCHASE_INVOICE_SUCCESS',
        'FETCH_PURCHASE_INVOICE_FAIL',
      ],
    },
  };
}

export function triggerPurchaseInvoiceSync(chainId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_purchase_invoice/trigger_sync/`,
      types: [
        'TRIGGER_PURCHASE_INVOICE_SYNC_REQUEST',
        'TRIGGER_PURCHASE_INVOICE_SYNC_SUCCESS',
        'TRIGGER_PURCHASE_INVOICE_SYNC_FAIL',
      ],
      data: { chain_id: chainId },
    },
  };
}

export function enrichPurchaseInvoice(invoiceId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_purchase_invoice/${invoiceId}/enrich/`,
      types: [
        'ENRICH_PURCHASE_INVOICE_REQUEST',
        'ENRICH_PURCHASE_INVOICE_SUCCESS',
        'ENRICH_PURCHASE_INVOICE_FAIL',
      ],
    },
  };
}

export function reincludePurchaseInvoice(invoiceId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_purchase_invoice/${invoiceId}/reinclude/`,
      types: [
        'REINCLUDE_PURCHASE_INVOICE_REQUEST',
        'REINCLUDE_PURCHASE_INVOICE_SUCCESS',
        'REINCLUDE_PURCHASE_INVOICE_FAIL',
      ],
    },
  };
}

export function setPurchaseInvoiceHold(invoiceId, hold, reason) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_purchase_invoice/${invoiceId}/set_invoicing_hold/`,
      data: { hold, reason },
      types: [
        'SET_PURCHASE_INVOICE_HOLD_REQUEST',
        'SET_PURCHASE_INVOICE_HOLD_SUCCESS',
        'SET_PURCHASE_INVOICE_HOLD_FAIL',
      ],
    },
  };
}

export function deletePurchaseInvoice(invoiceId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/chain_purchase_invoice/${invoiceId}/`,
      types: [
        'DELETE_PURCHASE_INVOICE_REQUEST',
        'DELETE_PURCHASE_INVOICE_SUCCESS',
        'DELETE_PURCHASE_INVOICE_FAIL',
      ],
      additionalData: { invoiceId },
    },
  };
}

// Consolidated Invoices

export function fetchConsolidatedInvoices(chainId, params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/`,
      types: [
        'FETCH_CONSOLIDATED_INVOICES_REQUEST',
        'FETCH_CONSOLIDATED_INVOICES_SUCCESS',
        'FETCH_CONSOLIDATED_INVOICES_FAIL',
      ],
      params: { chain_id: chainId, ...params },
    },
  };
}

export function fetchConsolidatedInvoice(invoiceId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/${invoiceId}/`,
      types: [
        'FETCH_CONSOLIDATED_INVOICE_REQUEST',
        'FETCH_CONSOLIDATED_INVOICE_SUCCESS',
        'FETCH_CONSOLIDATED_INVOICE_FAIL',
      ],
    },
  };
}

export function composeConsolidatedInvoice(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/compose/`,
      types: [
        'COMPOSE_CONSOLIDATED_INVOICE_REQUEST',
        'COMPOSE_CONSOLIDATED_INVOICE_SUCCESS',
        'COMPOSE_CONSOLIDATED_INVOICE_FAIL',
      ],
      data,
    },
  };
}

export function markConsolidatedInvoiceReady(invoiceId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/${invoiceId}/mark_ready/`,
      types: [
        'MARK_CONSOLIDATED_INVOICE_READY_REQUEST',
        'MARK_CONSOLIDATED_INVOICE_READY_SUCCESS',
        'MARK_CONSOLIDATED_INVOICE_READY_FAIL',
      ],
    },
  };
}

export function exportConsolidatedInvoiceToNetvisor(invoiceId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/${invoiceId}/export_to_netvisor/`,
      types: [
        'EXPORT_CONSOLIDATED_INVOICE_REQUEST',
        'EXPORT_CONSOLIDATED_INVOICE_SUCCESS',
        'EXPORT_CONSOLIDATED_INVOICE_FAIL',
      ],
    },
  };
}

export function deleteConsolidatedInvoice(invoiceId) {
  return {
    [API]: {
      method: DELETE,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/${invoiceId}/`,
      types: [
        'DELETE_CONSOLIDATED_INVOICE_REQUEST',
        'DELETE_CONSOLIDATED_INVOICE_SUCCESS',
        'DELETE_CONSOLIDATED_INVOICE_FAIL',
      ],
      additionalData: { invoiceId },
    },
  };
}

export function updateConsolidatedInvoiceDraft(invoiceId, data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/${invoiceId}/update_draft/`,
      types: [
        'UPDATE_CONSOLIDATED_INVOICE_DRAFT_REQUEST',
        'UPDATE_CONSOLIDATED_INVOICE_DRAFT_SUCCESS',
        'UPDATE_CONSOLIDATED_INVOICE_DRAFT_FAIL',
      ],
      data,
    },
  };
}

export function fetchComposePreview(data) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/compose_preview/`,
      types: [
        'FETCH_COMPOSE_PREVIEW_REQUEST',
        'FETCH_COMPOSE_PREVIEW_SUCCESS',
        'FETCH_COMPOSE_PREVIEW_FAIL',
      ],
      data,
    },
  };
}

export function clearComposePreview() {
  return { type: 'CLEAR_COMPOSE_PREVIEW' };
}

export function createConsolidatedInvoiceCreditNote(invoiceId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/${invoiceId}/create_credit_note/`,
      types: [
        'CREATE_CREDIT_NOTE_REQUEST',
        'CREATE_CREDIT_NOTE_SUCCESS',
        'CREATE_CREDIT_NOTE_FAIL',
      ],
    },
  };
}

export function copyConsolidatedInvoiceToDraft(invoiceId) {
  return {
    [API]: {
      method: POST,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/${invoiceId}/copy_to_draft/`,
      types: [
        'COPY_CONSOLIDATED_INVOICE_REQUEST',
        'COPY_CONSOLIDATED_INVOICE_SUCCESS',
        'COPY_CONSOLIDATED_INVOICE_FAIL',
      ],
    },
  };
}

export function fetchConsolidatedInvoicePreview(invoiceId) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_consolidated_invoice/${invoiceId}/preview/`,
      types: [
        'FETCH_CONSOLIDATED_INVOICE_PREVIEW_REQUEST',
        'FETCH_CONSOLIDATED_INVOICE_PREVIEW_SUCCESS',
        'FETCH_CONSOLIDATED_INVOICE_PREVIEW_FAIL',
      ],
    },
  };
}

// Audit Logs

export function fetchChainAuditLogs(chainId, params) {
  return {
    [API]: {
      method: GET,
      url: `${API_URL}/uiapi/1/chain_audit_log/`,
      types: [
        'FETCH_CHAIN_AUDIT_LOGS_REQUEST',
        'FETCH_CHAIN_AUDIT_LOGS_SUCCESS',
        'FETCH_CHAIN_AUDIT_LOGS_FAIL',
      ],
      params: { chain_id: chainId, ...params },
    },
  };
}

// Local state actions

export function setSelectedChain(chainId) {
  return {
    type: 'SET_SELECTED_CHAIN',
    chainId,
  };
}

export function clearChainState() {
  return {
    type: 'CLEAR_CHAIN_STATE',
  };
}
